import React from 'react';
import styled from '@emotion/styled';
import { background, border } from 'styled-system';

import { Link } from 'common/components/Link';
import { BodyRegularBR2 } from 'common/components/Typography';
import { getTrackerProps } from 'common/tracking/getTrackerProps';
import type { Breadcrumb as BaseBreadcrumb } from 'common/types/Breadcrumb';

interface Breadcrumb extends BaseBreadcrumb {
  disabled?: boolean;
  className?: string;
}

const BreadcrumbsLink = styled(Link)<any>`
  ${background};
  ${border};
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const breadcrumbsLinkStyles = {
  background: 'none',
  border: 'none',
};

const Breadcrumb = ({ url, name, disabled, onClick, className }: Breadcrumb) =>
  disabled ? (
    <BodyRegularBR2 as="span" data-testid="breadcrumbs-label" className={className}>
      {name}
    </BodyRegularBR2>
  ) : (
    <BreadcrumbsLink
      as={url ? 'a' : 'button'}
      {...breadcrumbsLinkStyles}
      {...getTrackerProps(
        {
          'data-testid': 'breadcrumbs-link',
          ...(url ? { href: url } : {}),
          onClick,
        },
        {
          event: 'breadcrumbs_tracking',
          placement: 'showroomPage',
          labelIdentifier: 'h24_breadcrumb_link',
        }
      )}
      className={className}
    >
      <BodyRegularBR2 as="span" color="inherit">
        {name}
      </BodyRegularBR2>
    </BreadcrumbsLink>
  );

export default Breadcrumb;
